import { memo } from "react";

import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getGenerateCode,
    getLandingPageTemplates,
    postCreateLandingPage,
    putUpdateLandingPage,
} from "../../../../../../redux/slices/landingPages/landingPages.asyncActions";
import { clearState } from "../../../../../../redux/slices/landingPages/landingPages.slice";
import TemplateStep from "./TemplateStep.layout";

const mapStateToProps = (state: any) => ({
    language: state.languagesState.languages,
    landingPageForm: state.landingPages.landingPageForm,
    landingPageFormStep: state.landingPages.landingPageFormStep,
    landingPageDetails: state.landingPages.landingPageDetails,
    customSources: state.landingPages.customSources,

    appDetails: state.landingPages.appDetails,
    code: state.landingPages.code,
    isLandingPageCreated: state.landingPages.isLandingPageCreated,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,
    templates: state.landingPages.templates,
    gamificationTemplates: state.landingPages.gamificationTemplates,
});

const mapDispatchToProps = (dispatch: any): any => ({
    dispatchGetTemplates: () => dispatch(getLandingPageTemplates()),
    dispatchClearState: (payload: any) => dispatch(clearState(payload)),
    dispatchGenerateCode: () => dispatch(getGenerateCode()),
    dispatchCreateLandingPage: (payload: any) =>
        dispatch(postCreateLandingPage(payload)),
    dispatchPutUpdateLandingPage: (payload: any) =>
        dispatch(putUpdateLandingPage(payload)),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(TemplateStep));
